import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { getData, postData } from "../../api/api"; // Adjust the import path as necessary
import { useStorage } from "../../hooks/useLocalStorage";

export default function Payment() {
  const location = useLocation();
  const navigate = useNavigate();
  const [use, setUse] = useStorage("use", null);

  useEffect(() => {
    // Extract query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const paymentId = searchParams.get("paymentId");
    const PayerID = searchParams.get("PayerID");
    console.log(paymentId);
    console.log(PayerID);

    postData("/payments/payment-success", {
      payPalPaymentId: paymentId,
      payerId: PayerID,
    })
      .then((postResponse) => {
        console.log("POST /payments/payment-success response:", postResponse);
      })
      .catch((postError) => {
        console.error("Error in POST /payments/payment-success:", postError);
      });
  }, [location.search]);

  return (
    <div className="m-auto flex justify-center p-20 mb-40">
      <div className="bg-white rounded-lg shadow-xl  w-auto p-6 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Check className="w-8 h-8 text-green-500" />
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Payment Successful
        </h2>

        <p className="text-gray-600 mb-6">
          You now have access to all course features.
        </p>

        <button
          onClick={() => navigate("/")}
          className="w-full py-2 px-4 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors duration-200"
        >
          Go back to Home
        </button>
      </div>
    </div>
  );
}
